import { dayKeyMtl } from "../../lib/dateMtl";

// Sélecteur de période « Du … Au … » (demande du propriétaire, 2026-10-06) : deux
// champs CALENDRIER (popup natif du navigateur) + RACCOURCIS (Aujourd'hui, Hier,
// 7 jours, 30 jours), ajoutés EN PLUS des regroupements existants — les tableaux
// de rapports n'affichent que les lignes entre les 2 dates. « Aujourd'hui » est
// calculé à l'HEURE DE MONTRÉAL (règle permanente du propriétaire).
export function RangePicker({ from, to, setFrom, setTo, idp }) {
  const champ = "bg-ink border border-ivory/15 rounded-lg px-2 py-1.5 text-xs text-ivory [color-scheme:dark] focus:border-gold focus:outline-none transition-colors";
  const raccourcis = [["Aujourd'hui", { j: 0 }], ["Hier", { j: 1, finAussi: true }],
                      ["1 sem.", { j: 6 }], ["1 mois", { mois: 1 }],
                      ["3 mois", { mois: 3 }], ["1 an", { ans: 1 }]];
  const applique = (r) => {
    const fin = new Date();
    const debut = new Date();
    if (r.j) debut.setDate(debut.getDate() - r.j);
    if (r.mois) debut.setMonth(debut.getMonth() - r.mois);
    if (r.ans) debut.setFullYear(debut.getFullYear() - r.ans);
    if (r.finAussi) fin.setDate(fin.getDate() - r.j);
    setFrom(dayKeyMtl(debut));
    setTo(dayKeyMtl(fin));
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${idp}-range`}>
      <label className="text-xs text-ivory/55 flex items-center gap-1.5">
        Du
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
          data-testid={`${idp}-from`} className={champ} />
      </label>
      <label className="text-xs text-ivory/55 flex items-center gap-1.5">
        Au
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
          data-testid={`${idp}-to`} className={champ} />
      </label>
      <span className="flex items-center gap-1.5 flex-wrap">
        {raccourcis.map(([lbl, r]) => (
          <button key={lbl} type="button" onClick={() => applique(r)}
            data-testid={`${idp}-preset-${lbl.toLowerCase().replace(/['.]/g, "").replace(/ /g, "-")}`}
            className="text-[11px] border border-ivory/20 text-ivory/60 px-2.5 py-1 rounded-full hover:border-gold hover:text-gold transition-colors">
            {lbl}
          </button>
        ))}
      </span>
      {(from || to) && (
        <button type="button" onClick={() => { setFrom(""); setTo(""); }}
          data-testid={`${idp}-reset`}
          className="text-xs text-gold hover:text-champagne underline underline-offset-2 transition-colors">
          Réinitialiser
        </button>
      )}
    </div>
  );
}
